import {combineReducers} from "redux";
import {LoginState} from '../../enums/AuthState';
import {Constants} from '../../constants/Constants';

const appReducer = (state: any | {}, action: any) => {
    if (action.type === Constants.START_LOGIN) {
        if (state[Constants.AUTH_EMAIL] && state[Constants.AUTH_PASSWORD]) {
            state[Constants.LOGIN_STATE] = LoginState.STARTED
        } else {
            state[Constants.LOGIN_STATE] = LoginState.IDLE;
        }
    } else if (action.type === Constants.REGISTERED_USERS_COUNT) {
        let existingCount = state[Constants.REGISTERED_USERS_COUNT] ?? 0;
        let newCount = action.payload as number;
        if (newCount > existingCount) {
            state[Constants.REGISTERED_USERS_COUNT] = newCount;
        }
    } else {
        let payload = action.payload;
        if (payload !== undefined) {
            Object.assign(state, payload);
        }
    }
    return state || {};
}

export const rootReducer = combineReducers({
    appReducer: appReducer,
});